export interface ScheduleSection {
  sectionId: number;
  mipreuId: number;
  programName: string;
  subjectId: number | null;
  subjectName: string | null;
  teachers: string[];
  studentsCount: number;
}

export interface ScheduleRoom {
  classroom: string;
  overCapacity: boolean;
  cells: { [weekDay: string]: ScheduleSection[] };
}

export interface ScheduleTimeBlock {
  startTime: string;
  endTime: string;
  rooms: ScheduleRoom[];
}

export interface RoomsSchedule {
  weekDays: string[];
  timeBlocks: ScheduleTimeBlock[];
  roomsCount: number | null;
}

export interface LocationData {
  id: string;
  name: string;
  address?: string;
}

// El backend entrega el día en minúscula sin tilde (enum de time_slots.week_day).
export const WEEK_DAY_LABELS: { [weekDay: string]: string } = {
  lunes: 'Lunes',
  martes: 'Martes',
  miercoles: 'Miércoles',
  jueves: 'Jueves',
  viernes: 'Viernes',
  sabado: 'Sábado',
  domingo: 'Domingo',
};

export const EMPTY_SCHEDULE: RoomsSchedule = {
  weekDays: [],
  timeBlocks: [],
  roomsCount: null,
};
